import { ArrayOps } from '../lift';
/**
 * Filters all the falsy elements out of this Array.
 * All occurences of false, null, undefined, 0, "" will be removed.
 */
export function compact() {
    return this.filter(function (x) { return !!x; });
}
ArrayOps.prototype.compact = compact;
